export const colors = {
  fireRed: {
    5: '#FFE8E5',
    10: '#FFD2CC',
    15: '#FFBBB2',
    20: '#FFA599',
    30: '#FF7866',
    35: '#FF614D',
    40: '#FF4B33',
    50: '#FF1E00',
    60: '#CC1800',
    65: '#B21500',
    70: '#991200',
    80: '#660C00',
    85: '#4D0900',
  },
  neutral: {
    0: '#FFFFFF',
    2: '#F8F8FA',
    5: '#EDEDF2',
    8: '#E4E4EB',
    10: '#DCDCE5',
    15: '#CECED9',
    20: '#C2C2CC',
    30: '#A8A8B2',
    40: '#8E8E99',
    50: '#777780',
    60: '#5F5F66',
    70: '#47474D',
    80: '#2F2F33',
    85: '#242426',
    90: '#18181A',
    95: '#0C0C0D',
    100: '#000000',
  },
  rubyRed: {
    5: '#FFE9EC',
    15: '#FFBEC5',
    30: '#FF7D8C',
    40: '#FF5165',
    50: '#FF263F',
    70: '#991726',
  },
  green: {
    5: '#E5F9EB',
    15: '#B2EEC3',
    30: '#66DC87',
    40: '#33D15F',
    50: '#00C537',
    70: '#007621',
  },
  lightOrange: {
    5: '#FFF3E5',
    15: '#FFDCB2',
    30: '#FFB966',
    40: '#FFA133',
    50: '#FF8A00',
    70: '#995300',
  },
  lightPurple: {
    5: '#F0EFFE',
    10: '#E1DFFC',
    15: '#D2D0FB',
    20: '#C3C0FA',
    30: '#A4A0F7',
    40: '#8681F5',
    50: '#6861F2',
    60: '#544ECA',
    70: '#403BA1',
    80: '#2D2979',
    85: '#231F65',
    90: '#191650',
  },
  purple: {
    5: '#F2EAFC',
    10: '#E5D5F9',
    15: '#D8BFF6',
    20: '#CBAAF3',
    30: '#B180EE',
    40: '#9755E8',
    50: '#7D2BE2',
    60: '#6422B5',
    70: '#4B1A88',
    80: '#23115A',
    85: '#260D44',
    90: '#19092D',
  },
  blue: {
    5: '#EEF1FF',
    15: '#CBD4FF',
    30: '#97A9FF',
    50: '#5270FF',
    60: '#425ACC',
    70: '#314399',
  },
  orange: {
    5: '#FFF1E6',
    15: '#FFD5B3',
    30: '#FEAD67',
    50: '#FE7301',
    60: '#CB5C01',
    70: '#984501',
  },
  pink: {
    5: '#FCF0FD',
    15: '#F7D3FA',
    30: '#EEA7F5',
    50: '#E36DEF',
    60: '#B657BF',
    70: '#88418F',
  },
  turquoise: {
    5: '#EBFCFD',
    15: '#C3F7FA',
    30: '#86F0F6',
    50: '#36E6F0',
    60: '#2BB8C0',
    70: '#208A90',
  },
  yellow: {
    5: '#FFF9ED',
    15: '#FFEEC8',
    30: '#FFDC91',
    50: '#FFC547',
    60: '#CC9E39',
    70: '#99762B',
  },
  lightBlue: {
    5: '#E9F9FF',
    15: '#BDEEFF',
    30: '#7CDEFF',
    50: '#24C8FF',
    60: '#1DA0CC',
    70: '#167899',
  },
};
